import StyleSheet from 'react-native-media-query';
import {
  BASESTYLE,
  COLORS,
  FONT_NAMES,
  FixedValue,
  GlobalStyleValues,
  Percentage,
} from '../../constants';
import {IColorTheme} from '../../types/contextTypes/themeContext';
import {
  isWebsite,
  normalizeFont,
  scaleHeight,
  scaleWidth,
} from '../../utils/responsive';

export const PaymentSuccessStyle = (_theme: IColorTheme) =>
  StyleSheet.create({
    mainContainer: {
      ...BASESTYLE.flex1,
      backgroundColor: _theme.backgroundColor,
      ...BASESTYLE.alignCenter,
    },
    requestView: {
      position: GlobalStyleValues.ABSOLUTE,
      ...BASESTYLE.alignCenter,
      zIndex: FixedValue.CONSTANT_VALUE_10,
      ...BASESTYLE.flex1,
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_229),
    },
    button: {
      width: scaleHeight(FixedValue.CONSTANT_VALUE_250),
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      borderRadius: FixedValue.CONSTANT_VALUE_100,
    },
    yesButtonLabelstyle: {
      fontFamily: FONT_NAMES.SF_MEDIUM,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_17),
      color: COLORS.WHITE,
    },
    request: {
      fontFamily: FONT_NAMES.SF_MEDIUM,
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_32),
      ...BASESTYLE.textAlignCenter,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_24),
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_25),
      color: _theme.color,
    },
    wait: {
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_22),
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      fontFamily: FONT_NAMES.SF_LIGHT,
      ...BASESTYLE.textAlignCenter,
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_17),
      color: _theme.color,
    },
  });
